export const SIMULATOR_PATH = '/simulateur/bilan'
